/**
 * Compare if the object value is Falsy, if it is, return the source value
 */
export function orComparator(objValue: any, srcValue: any) {
  return objValue || srcValue;
}
